var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvaxlpm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 15.5V13.25L12 16.875V19.25L5.75 15.5Z",
    fill: "#993A5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 18.75V17L18.125 15.5V17.125L15.75 18.75Z",
    fill: "#3E1C28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17.1785V18.875L12.75 20.5V18.75L15.5 17.1785Z",
    fill: "#401B2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 18.5L15.75 18.75V17L15.5 17.1772V18.5Z",
    fill: "#29151E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 18.75V20.5L9.5 18.375L10.125 17.875L12 19.25L12.75 18.75Z",
    fill: "#29151E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 15.75L12 19.25V16.875L18.25 13.25V15.75Z",
    fill: "#C03657"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 6.375L11.875 9.875L17.875 6.375L11.875 2.75L5.75 6.375Z",
    fill: "#F2726B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 8.625V6.375L11.875 9.875V12.25L5.75 8.625Z",
    fill: "#A04640"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 13.25V8.625L11.875 12.25V17.25L5.75 13.25Z",
    fill: "#8A6B5A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 17.25V12.25L17.875 8.75V13.75L11.875 17.25Z",
    fill: "#C29784"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 11L8 10.75L8.375 10.375L9.125 10.75V12.875L11.875 16.125L17.6925 12.7509C17.8845 12.6395 18.125 12.778 18.125 13L11.875 16.75L8.625 13.125V11Z",
    fill: "#FFFBF7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.25V10.75L8.625 11V13.125L11.875 16.75V17.25L7.375 14.375L8 13.25Z",
    fill: "#888A8B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 17.25V16.75L18.125 13V13.3992C18.125 13.6263 18.0477 13.8466 17.9059 14.0239L15.625 16.875L11.875 17.25Z",
    fill: "#D8D5D6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 14.375V12.625L13.5 12.5C13.8934 12.1066 14.4492 11.9213 15 12V13.375L13.375 14.375Z",
    fill: "#FDFFFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 12.875V11.125L16.25 11C16.6434 10.6066 17.1992 10.4213 17.75 10.5V11.875L16.125 12.875Z",
    fill: "#FDFFFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 12.875V13.75L15 13.375V12.5L14.375 12.875Z",
    fill: "#160309"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 11.375V12.25L17.75 11.875V11L17.125 11.375Z",
    fill: "#160309"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 12.25V9.875L17.875 6.375V8.75L11.875 12.25Z",
    fill: "#DB5A54"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 11.75L13.5 10.5V11.25L15.375 12.5V11.75Z",
    fill: "#9F3F37"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 11.75V12.5L15.7507 12.1532C16.5731 11.3941 17.5553 10.8291 18.625 10.5V9.75C17.5553 10.0791 16.5731 10.6441 15.7507 11.4032L15.375 11.75Z",
    fill: "#DB5B52"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 11.75L13.5 10.5C14.3675 9.67379 15.3803 9.01505 16.4873 8.55699L16.625 8.5L18.625 9.75L18.4753 9.80986C17.3343 10.2663 16.2843 10.9234 15.375 11.75Z",
    fill: "#F2746C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.25V16.75L8.25 18V19.625L6 18.25Z",
    fill: "#866B59"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 18V19.625L10.25 18.25V16.75L8.25 18Z",
    fill: "#C8907C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16.5L8.25 18L6.25 15L5.5 15.5V16.5Z",
    fill: "#993A5F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 16.75L8.25 18L6.25 15L7.375 14.375L10.25 16.75Z",
    fill: "#C03657"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaxlpm);
export default __webpack_public_path__ + "static/media/avaxlpm.7086c6ebba8bf063921891cd9e27205a.svg";
export { ForwardRef as ReactComponent };